export class SharepointResponse {
  message: string;
  sharepoint: SharepointData;
}

export class SharepointData {
  accessToken: string;
  fileId: string;
  fileUrl: string;
  fileName: string;
  contentType: string;
  mimeType: string;
}

export class SharepointFile {
  name: string;
  displayName: string;
  source: string;
  contentType: string;
  mimeType: string;
  publicationDate: number;
  updateDate: number;
  size:number;
}

export class SharepointContent {
  content: Blob;
  name: string;

  constructor(content: Blob, name: string) {
    this.content = content;
    this.name = name;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/sharepoint-data.ts